import { render } from "./permissao.vue?vue&type=template&id=75a97ffe&scoped=true"
import script from "./permissao.vue?vue&type=script&lang=js"
export * from "./permissao.vue?vue&type=script&lang=js"

import "./permissao.vue?vue&type=style&index=0&id=75a97ffe&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a97ffe"]])

export default __exports__